// Direct copy of error codes from the appointment service: https://github.com/Audibene-GMBH/ta-appointment-service/blob/develop/src/utils/error-code.ts
enum ErrorCode {
  APP_STATE_MANAGER_GRACEFUL_SHUTDOWN_ERROR = 'APP_STATE_MANAGER_GRACEFUL_SHUTDOWN_ERROR',
  APPOINTMENT_IDS_DO_NOT_EXIST = 'APPOINTMENT_IDS_DO_NOT_EXIST',
  BAD_REQUEST = 'BAD_REQUEST',
  BOOKING_RESERVED_SLOT_NOT_ALLOWED = 'BOOKING_RESERVED_SLOT_NOT_ALLOWED',
  CONSTRAINT_BLOCKS_NOT_GENERATED = 'CONSTRAINT_BLOCKS_NOT_GENERATED',
  DATABASE_CONNECTION_ERROR = 'DATABASE_CONNECTION_ERROR',
  DOUBLE_BOOKING_HEARING_AID_EVALUATION_NOT_ALLOWED = 'DOUBLE_BOOKING_HEARING_AID_EVALUATION_NOT_ALLOWED',
  FAILED_TO_CREATE_APPOINTMENT_IN_TCM = 'FAILED_TO_CREATE_APPOINTMENT_IN_TCM',
  FAILED_TO_FETCH_RESOURCE_CALENDAR_INTEGRATION_AVAILABILITIES = 'FAILED_TO_FETCH_RESOURCE_CALENDAR_INTEGRATION_AVAILABILITIES',
  FAILED_TO_GET_TCM_RESOURCES_FOR_CLINIC = 'FAILED_TO_GET_TCM_RESOURCES_FOR_CLINIC',
  FORBIDDEN = 'FORBIDDEN',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_APPOINTMENT_STATUS_UPDATE = 'INVALID_APPOINTMENT_STATUS_UPDATE',
  INVALID_APPOINTMENT_TYPE_CONFIGURATION = 'INVALID_APPOINTMENT_TYPE_CONFIGURATION',
  INVALID_APPOINTMENT_TYPE_FOR_RESOURCE_CALENDAR_INTEGRATION = 'INVALID_APPOINTMENT_TYPE_FOR_RESOURCE_CALENDAR_INTEGRATION',
  INVALID_APPOINTMENT_TYPE_MAPPING = 'INVALID_APPOINTMENT_TYPE_MAPPING',
  INVALID_AUTHENTICATION_KEY_ERROR = 'INVALID_AUTHENTICATION_KEY_ERROR',
  INVALID_AVAILABILITY_CONSTRAINT_APPOINTMENT_TYPE = 'INVALID_AVAILABILITY_CONSTRAINT_APPOINTMENT_TYPE',
  INVALID_AVAILABILITY_CONSTRAINT_RECURRENCE_RULE_SET_FORMAT = 'INVALID_AVAILABILITY_CONSTRAINT_RECURRENCE_RULE_SET_FORMAT',
  INVALID_AVAILABILITY_REPORT_AVAILABILITY = 'INVALID_AVAILABILITY_REPORT_AVAILABILITY',
  INVALID_AVAILABILITY_REPORT_DELIVERY_MODEL = 'INVALID_AVAILABILITY_REPORT_DELIVERY_MODEL',
  INVALID_CUSTOMER_ASSIGNMENT = 'INVALID_CUSTOMER_ASSIGNMENT',
  INVALID_CUSTOMER_GID = 'INVALID_CUSTOMER_GID',
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  INVALID_DURATION_IN_MINUTES = 'INVALID_DURATION_IN_MINUTES',
  INVALID_ID_FORMAT = 'INVALID_ID_FORMAT',
  INVALID_PAYLOAD = 'INVALID_PAYLOAD',
  INVALID_RESOURCE = 'INVALID_RESOURCE',
  INVALID_RESOURCE_ASSIGNMENT = 'INVALID_RESOURCE_ASSIGNMENT',
  INVALID_RESOURCE_IDS = 'INVALID_RESOURCE_IDS',
  INVALID_SHOP_STATUS = 'INVALID_SHOP_STATUS',
  INVALID_UPDATE_FIELD = 'INVALID_UPDATE_FIELD',
  LEAD_RESERVATION_ALREADY_EXISTS = 'LEAD_RESERVATION_ALREADY_EXISTS',
  PROVIDER_HISTORY_UNAVAILABLE = 'PROVIDER_HISTORY_UNAVAILABLE',
  PULSAR_ERROR = 'PULSAR_ERROR',
  PULSAR_PRODUCER_ERROR = 'PULSAR_PRODUCER_ERROR',
  REPOSITORY_CONSTRAINT_ERROR = 'REPOSITORY_CONSTRAINT_ERROR',
  REPOSITORY_ERROR = 'REPOSITORY_ERROR',
  REPOSITORY_NOT_FOUND_ERROR = 'REPOSITORY_NOT_FOUND_ERROR',
  REPOSITORY_TRANSACTION_ERROR = 'REPOSITORY_TRANSACTION_ERROR',
  REQUESTED_TIME_SLOT_UNAVAILABLE = 'REQUESTED_TIME_SLOT_UNAVAILABLE',
  RESERVATION_NOT_FOUND = 'RESERVATION_NOT_FOUND',
  RESERVATION_STATUS_CHANGE = 'RESERVATION_STATUS_CHANGE',
  RESERVATION_EXPIRED = 'RESERVATION_EXPIRED',
  RESERVATION_CONVERT_ERROR = 'RESERVATION_CONVERT_ERROR',
  RESERVATION_RESOURCE_NOT_FOUND = 'RESERVATION_RESOURCE_NOT_FOUND',
  RESOURCE_APPOINTMENT_DURATION_UNKNOWN = 'RESOURCE_APPOINTMENT_DURATION_UNKNOWN',
  RESOURCE_CALENDAR_INTEGRATION_INVALID_SHOP_ID = 'RESOURCE_CALENDAR_INTEGRATION_INVALID_SHOP_ID',
  RESOURCE_CALENDAR_INTEGRATION_NOT_CONFIGURED = 'RESOURCE_CALENDAR_INTEGRATION_NOT_CONFIGURED',
  RESOURCE_CALENDAR_INTEGRATION_NOT_FOUND = 'RESOURCE_CALENDAR_INTEGRATION_NOT_FOUND',
  RESOURCE_RESERVATION_ALREADY_EXISTS = 'RESOURCE_RESERVATION_ALREADY_EXISTS',
  SALESFORCE_MAPPING_ERROR = 'SALESFORCE_MAPPING_ERROR',
  SERVICE_PROVIDER_INTERFACE_ERROR = 'SERVICE_PROVIDER_INTERFACE_ERROR',
  SIGNAL_HANDLER_INITIALIZER_UNCAUGHT_EXCEPTION_ERROR = 'SIGNAL_HANDLER_INITIALIZER_UNCAUGHT_EXCEPTION_ERROR',
  SIGNAL_HANDLER_INITIALIZER_UNHANDLED_REJECTION_ERROR = 'SIGNAL_HANDLER_INITIALIZER_UNHANDLED_REJECTION_ERROR',
  START_DATE_IN_PAST = 'START_DATE_IN_PAST',
  START_DATE_NO_LONGER_AVAILABLE = 'START_DATE_NO_LONGER_AVAILABLE',
  SYCLE_PRO_APPOINTMENT_TYPE_NOT_FOUND = 'SYCLE_PRO_APPOINTMENT_TYPE_NOT_FOUND',
  SYCLE_PRO_CLINIC_NOT_FOUND = 'SYCLE_PRO_CLINIC_NOT_FOUND',
  SYCLE_PRO_FAILED_TO_AUTHENTICATE = 'SYCLE_PRO_FAILED_TO_AUTHENTICATE',
  SYCLE_PRO_FAILED_TO_CREATE_APPOINTMENT = 'SYCLE_PRO_FAILED_TO_CREATE_APPOINTMENT',
  SYCLE_PRO_FAILED_TO_GET_APPOINTMENT_TYPES = 'SYCLE_PRO_FAILED_TO_GET_APPOINTMENT_TYPES',
  SYCLE_PRO_FAILED_TO_GET_CLINICS = 'SYCLE_PRO_FAILED_TO_GET_CLINICS',
  SYCLE_PRO_FAILED_TO_GET_OPEN_SLOTS = 'SYCLE_PRO_FAILED_TO_GET_OPEN_SLOTS',
  SYCLE_PRO_FAILED_TO_GET_REFERRAL_SOURCES = 'SYCLE_PRO_FAILED_TO_GET_REFERRAL_SOURCES',
  SYCLE_PRO_FAILED_TO_GET_STAFF = 'SYCLE_PRO_FAILED_TO_GET_STAFF',
  SYCLE_PRO_FAILED_TO_PROCESS_ARCHIVED_PATIENT = 'SYCLE_PRO_FAILED_TO_PROCESS_ARCHIVED_PATIENT',
  SYCLE_PRO_FAILED_TO_SEARCH_PATIENTS = 'SYCLE_PRO_FAILED_TO_SEARCH_PATIENTS',
  SYCLE_PRO_FAILED_TO_UPDATE_APPOINTMENT = 'SYCLE_PRO_FAILED_TO_UPDATE_APPOINTMENT',
  SYCLE_PRO_SHOP_APPOINTMENT_MAPPING_TYPE_NOT_FOUND = 'SYCLE_PRO_SHOP_APPOINTMENT_MAPPING_TYPE_NOT_FOUND',
  SYCLE_PRO_SHOP_MAPPING_NOT_FOUND = 'SYCLE_PRO_SHOP_MAPPING_NOT_FOUND',
  SYCLE_PRO_UNAVAILABLE_TIMES_NOT_SUPPORTED = 'SYCLE_PRO_UNAVAILABLE_TIMES_NOT_SUPPORTED',
  TCM_FAILED_TO_CREATE_PATIENT = 'TCM_FAILED_TO_CREATE_PATIENT',
  TCM_FAILED_TO_UPDATE_APPOINTMENT = 'TCM_FAILED_TO_UPDATE_APPOINTMENT',
  TCM_INVALID_COUNTRY = 'TCM_INVALID_COUNTRY',
  TCM_NO_AUTH_2_CLIENT_PROVIDED_TO_CONTACT_CLIENT = 'TCM_NO_AUTH_2_CLIENT_PROVIDED_TO_CONTACT_CLIENT',
  TCM_RESPONSE_ERROR = 'TCM_RESPONSE_ERROR',
  TELEAUDIOLOGY_CUSTOMER_CLIENT_FETCH_FAILED = 'TELEAUDIOLOGY_CUSTOMER_CLIENT_FETCH_FAILED',
  TELEAUDIOLOGY_CUSTOMER_CLIENT_FETCH_NOT_FOUND = 'TELEAUDIOLOGY_CUSTOMER_CLIENT_FETCH_NOT_FOUND',
  TIME_ZONE_NOT_PROVIDED = 'TIME_ZONE_NOT_PROVIDED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNHANDLED_OVERLAP_ERROR = 'UNHANDLED_OVERLAP_ERROR',
  UNSUPPORTED_READ_CALENDAR_INTEGRATION_TYPE = 'UNSUPPORTED_READ_CALENDAR_INTEGRATION_TYPE',
  UNSUPPORTED_SYCLE_PRO_REQUEST = 'UNSUPPORTED_SYCLE_PRO_REQUEST',
  UNSUPPORTED_WRITE_CALENDAR_INTEGRATION_TYPE = 'UNSUPPORTED_WRITE_CALENDAR_INTEGRATION_TYPE',
}

export { ErrorCode }
